import { Loading } from "@/shared/ui/feedback/Loading";

interface RefreshStatusProps {
  isRefreshing: boolean;
}

export function RefreshStatus({
  isRefreshing,
}: RefreshStatusProps): React.ReactElement {
  return (
    <output
      aria-live="polite"
      aria-atomic="true"
      className={
        isRefreshing
          ? "pointer-events-none fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-full border border-primary/40 bg-background px-6 py-4 text-base font-medium text-foreground shadow-xl ring-4 ring-primary/10"
          : undefined
      }
    >
      {isRefreshing && (
        <>
          <Loading size="md" className="motion-reduce:animate-none" />
          更新中
        </>
      )}
    </output>
  );
}
